import React from 'react'
import { Body } from 'components/Shell/Shell'
import { NavLink, Route } from 'react-router-dom'
import SavedPayments from 'components/SavedPayments/SavedPayments'
import './SystemAdmin.scss'

const ROUTES = process.env.ADDITIONAL_ROUTES.systemAdministration

const Components = {
  SavedPayments,
}

const SystemAdmin = ({ match, history }) => {
  const [drawerShown, setDrawerShown] = React.useState(false)
  const routeProps = { setDrawerShown, drawerShown }

  React.useEffect(() => {
    if (!match.params.parameter) {
      history.replace(`/system-admin/${ROUTES[0].parameter || ''}`)
    }
  }, [])

  return (
    <Body className="no-padding system-admin" showDrawer={drawerShown}>
      <Sidebar />
      <InnerBody>
        {ROUTES.map((route, i) => {
          const Component = Components[route.componentName]
          return (
            <Route
              path={`/system-admin/${route.parameter}`}
              exact
              render={(props) => <Component {...props} {...routeProps} />}
              key={route.component || i}
            />
          )
        })}
      </InnerBody>
    </Body>
  )
}

export default SystemAdmin

const Sidebar = () => (
  <aside className="body-sidebar">
    {ROUTES.map((route, i) => (
      <NavLink to={`/system-admin/${route.parameter}`} key={route.parameter || i}>
        {route.title}
      </NavLink>
    ))}
  </aside>
)

const InnerBody = ({ children }) => <div className="inner-body">{children}</div>



// WEBPACK FOOTER //
// ./src/components/SystemAdmin/SystemAdmin.js